@if (objectTypeInfoListDataSource$ | async; as objectTypeInfoListDataSource) {
  <div #rootContainer id="rootContainer">
    <div #introText id="introText">
      {{this.res.get('SelectOtAndGid-IntroText')}}
    </div>
    <dx-list
      #itemList
      id="itemList"
      [dataSource]="objectTypeInfoListDataSource"
      [showScrollbar]="'always'"
      [grouped]="isListGrouped"
      [collapsibleGroups]="isListGrouped"
      [pageLoadMode]="'scrollBottom'"
      (onItemClick)="listItemClick($event)"
      >
      <div *dxTemplate="let item of 'group'">
        <div class="group-header">
          {{ item.key ? item.items[0].groupObjectTypeDisplayTextPlural + ' (' + item.key + ')' : 'Objekttypen' }}
        </div>
      </div>
      <div *dxTemplate="let item of 'item'">
        <div class="list-item">
          {{ item.concreteObjectTypeName + ' (' + item.concreteObjectTypeDisplayTextSingular + ')' }}
        </div>
      </div>
    </dx-list>
    <dx-action-sheet
      #actionSheet
      id="actionSheet"
      [items]="actionSheetCommands"
      [title]="this.res.get('SelectOtAndGid-SelectIdentifier')"
      [showTitle]="true"
      [usePopover]="true"
      [target]="actionSheetTarget"
      [(visible)]="actionSheetVisible"
      (onItemClick)="actionSheetItemClicked($event)"
      >
    </dx-action-sheet>
    <div #bottomButtonBar id="bottomButtonBar" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="10px">
      <dx-button
        #cancelButton
        id="cancelButton"
        ngClass="bottom-button"
        stylingMode="outlined"
        [text]="this.res.get('Cancel')"
        type="normal"
        (onClick)="cancel()"
        >
      </dx-button>
    </div>
  </div>
}
